import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";

/**
 * Transforms a field value into an array of values for a select field
 * Filters only string/number values
 */
export function transformFieldValueToSelectValue(
  value: FieldValue,
): (string | number)[] {
  if (Array.isArray(value)) {
    return value.filter(
      (v) => typeof v === "string" || typeof v === "number",
    ) as (string | number)[];
  }

  if (
    value !== undefined &&
    (typeof value === "string" || typeof value === "number")
  ) {
    return [value as string | number];
  }

  return [];
}
